<template>
  <main>
    <header>
      <h1>{{ title }}</h1>
    </header>
    <ul>
      <h2>Mocktails</h2>
      <li v-for="(item, i) in mocktailItems" :key="i"> 
        <div class="top clearfix">

          <h3>{{ item.title }}</h3>
          <i class="price">&euro; {{ item.price }}</i>
          
        </div>
        <div class="bottom clearfix">
          <p>{{ item.description }}</p>
        </div>
      </li>
    </ul>
    <br/>
    <ul>
      <h2> Cocktails</h2>
      <li v-for="(item, i) in cocktailItems" :key="i"> 
        <div class="top clearfix">

          <h3>{{ item.title }}</h3>
          <i class="price">&euro; {{ item.price }}</i>
          
        </div>
        <div class="bottom clearfix">
          <p>{{ item.description }}</p>
        </div>
      </li>
    </ul>
  </main>
  
</template>

<script setup>
  const title = 'UZO Amsterdam'
  const cocktailItems = [
    {
      title: "Classic Mojito",
      price: '13,50',
      description: "White Rum, Lime, Mint, Sugar, Soda"
    },
    {
      title: "Espresso Martini",
      price: '14,00',
      description: "Espresso, Vodka, Coffee Liquor, Caramel"
    },
    {
      title: "Margarita",
      price: '14,00',
      description: "Tequila, Triple Sec, Lime, Sugar, Salt"
    },
    {
      title: "Whiskey Sour",
      price: '14,00',
      description: "Irish Whiskey, Lemon, Sugar, Egg White"
    },
    {
      title: "Amaretto Sour",
      price: '14,00',
      description: "Amaretto Liqueur, Lemon, Sugar, Egg White"
    },
    {
      title: "Irish Coffee",
      price: '9,50',
      description: "Irish Whiskey, Coffee, Sugar, Whipped Cream"
    },
    {
      title: "Negroni",
      price: '13,50',
      description: "Gin, Campari, Sweet Vermouth"
    },
    {
      title: "Old Fashioned",
      price: '14,00',
      description: "Rye Whiskey, Bitters, Sugar"
    },
    {
      title: "Long Island Iced Tea",
      price: '15,00',
      description: "Vodka, Gin, White Rum, Tequila, Triple Sec, Lemon, Sugar"
    },
    {
      title: "Aperol Spritz",
      price: '11,00',
      description: "Aperol, Prosecco, Soda, Orange"
    },
    {
      title: "Limoncello Spritz",
      price: '11,00',
      description: "Limoncello, Prosecco, Soda, Lemon"
    },
    {
      title: "Elderflower Spritz",
      price: '11,00',
      description: "Elderflower, Prosecco, Soda, Lime, Mint"
    }
  ]
  const mocktailItems = [
    {
      title: "Virgin Mojito 0%",
      price: '8,50',
      description: "Lime, Mint, Suagr, Soda"
    },
    {
      title: "Shirley Temple 0%",
      price: '8,50',
      description: "Grenadine, Lime, Ginger Ale"
    }
    
  ]
</script>
<style>
@import url('https://fonts.googleapis.com/css2?family=Lobster&display=swap');
/* 0a1a3a */
* {
  margin: 0;
  padding: 0;
}

.clearfix::after {
   content: "";
   display: table;
   clear: both;
}

body {
  font-family: "Lobster", sans-serif;
  font-weight: 100;
  font-style: normal;
  /* color: #fff; */
  
}

main {
  max-width: 500px;
  margin: 0 auto;
  padding: 0 20px;
 
}

header {
  text-align: center;
  padding: 20px 0;
  border-bottom: 1px solid #d4af37;
  margin-bottom: 40px;
}

h2 {
  margin-bottom: 20px;
}


ul {
  list-style: none;
  margin-bottom: 40px;
}

li {
  border: 1px solid #ccc;
  padding: 20px 20px;
  margin-bottom: 10px;
  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
}
.top {
  margin-bottom: 5px;
}
.bottom p {
  font-family: sans-serif;
  float: left;
  width: 100%;
  font-size: 13px;
  font-style: italic;
  color: #95a5a6;
}

h3 {
  float: left;
}

.price {
  float: right;
  color: #d4af37;
}

</style>